"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const PlotChart_1 = __importDefault(require("./PlotChart"));
const processSnapPlot_1 = require("./processSnapPlot");
const yLogBase = 2;
function Spectrum1DHistogram({ color = 'red', data, }) {
    const processedData = (0, react_1.useMemo)(() => {
        return (0, processSnapPlot_1.processSnapPlot)('1D', data, yLogBase);
    }, [data]);
    return ((0, jsx_runtime_1.jsxs)("div", { style: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
        }, children: [(0, jsx_runtime_1.jsx)("div", { style: { display: 'block' }, children: (0, jsx_runtime_1.jsx)(PlotChart_1.default, { data: processedData, sign: "positive", color: color, yLogBase: yLogBase }) }), (0, jsx_runtime_1.jsx)("div", { style: { display: 'block', width: 180, height: 180 }, children: (0, jsx_runtime_1.jsx)(PlotChart_1.default, { data: processedData, sign: "negative", color: color, yLogBase: yLogBase, hideHeading: true }) })] }));
}
exports.default = (0, react_1.memo)(Spectrum1DHistogram);
